
    var utils = require("!!/Users/v625154/work/perspective/packages/perspective-webpack-plugin/src/js/utils.js");
    module.exports = utils.publicPath(__webpack_public_path__) + "psp.async.wasm";
    


//////////////////
// WEBPACK FOOTER
// ../perspective/cjs/js/psp.async.wasm.js
// module id = 169
// module chunks = 0